<app-card [expandable]="true" [expanded]="true" [margin]=margin
          [title]="title">
    <ng-content></ng-content>
</app-card>